import { ReportsService } from './../../../apiclient/api/reports.service';
import { ExcelExporterService } from './../../../excel-exporter.service';
import { CustomForm } from './../../../apiclient/model/customForm';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Lightbox } from 'ngx-lightbox';

import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Point,Polygon} from 'ol/geom';
import {Style,Fill, Stroke} from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import Attribution from 'ol/control/Attribution';
import EditableReport from '../report-edition-interface';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';
import { GeometryEditorComponent } from './../../../components/geometry-editor/geometry-editor.component';
import { Observable } from 'rxjs';
import { CustomformComponent } from '../customform/customform.component';
import { CustomEntityFieldComponent } from '../custom-entity-field/custom-entity-field.component';

/**
 * Componente que renderiza el detall del informe de tipo Muestreo
 */
@Component({
  selector: 'ngx-sampling-lite',
  templateUrl: './sampling-lite.component.html',
  styleUrls: ['./sampling-lite.component.scss']
})
export class SamplingLiteComponent implements OnInit,AfterViewInit,EditableReport {

  dropdownSettings = {
    singleSelection: false,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };

  dropdownSettingsSingle = {
    singleSelection: true,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };

  report: any = {};
  customform: any = {}
  customfields: any[] = []
  sourcesList: any;
  map: Map;
  feature: Feature;
  vectorSource: VectorSource;
  config: any = {
    target: 'visormapreportsampling',
    center : [-5.6954768,40.9670626],
  }

  geometryEditable = false
  editionEnabled: Boolean;

  /**
   * Carga el reporte en el detalle
   */
  @Input()
  set loadReport(val: any){

    this.userSessionService.getCustomForm(val.customform_id).subscribe(async (customform) => {
      this.customfields = [];

      this.customform = customform;
      await this.generateSourcesList()
      console.log(customform);
      this.report = JSON.parse(JSON.stringify(val));

      this.report.reportUser = this.report.reportUser.name + " " +this.report.reportUser.surname;
      this.report.datetime = moment(this.report.datetime).format('DD/MM/YYYY, HH:mm');

      if(this.report.imagen != '' && null != this.report.imagen){
        this.report.imagen = 'https://api.smartrural.es:8084/v1/image/report' + this.report.imagen;
      }

      if(this.report.showLocation && typeof this.vectorSource != 'undefined'){
        this.vectorSource.clear();
       // this.initMap();
        this.loadLocation()
      }

    })

  }


  @ViewChild('customFormInstance')
  customForm: CustomformComponent;


  constructor(private lightbox: Lightbox, private userSessionService: UserSessionService,
    private sanitizer: DomSanitizer,private dialogService: NbDialogService,
    private toastService: NbToastrService, private excelService: ExcelExporterService,
    private reportService: ReportsService) { }
  enableEdition(enableEd: Boolean): void {
    this.editionEnabled = enableEd;

  }

    /**
     * @ignore
     */
  canEdit(): Boolean {
    throw new Error('Method not implemented.');
  }

  /**
   * Guarda el reporte
   * @returns
   */
  saveReport(): Promise<any> {
    return new Promise((resolve,reject) => {
      let reportToSave: any = this.customForm.saveReport();



      if (typeof this.report.form_data.location != 'undefined'){
        reportToSave[this.customform.dynamic_form.Fields.find( e => e.type === 'location').id] = this.report.form_data.location
      }

      this.excelService.validarSingleCustomForm(this.customform,reportToSave,null,null)


      Object.keys(reportToSave).filter( k => k!= 'errorMessage').forEach(k => {
        if(null != reportToSave[k] && reportToSave[k].errorMessage != undefined && reportToSave[k].errorMessage != null && reportToSave[k].errorMessage.length > 0){
          reportToSave.errorMessage = reportToSave.errorMessage.concat(reportToSave[k].errorMessage)
        }else if(Array.isArray(reportToSave[k])){
          reportToSave[k].forEach(v => {
            if(v.errorMessage != undefined && v.errorMessage != null && v.errorMessage.length > 0){
              reportToSave.errorMessage = reportToSave.errorMessage.concat(v.errorMessage)
              delete v.errorMessage;
            }
          })
        }
      })

      if (reportToSave.errorMessage != undefined && reportToSave.errorMessage != null && reportToSave.errorMessage.length > 0){

        reject('Se han producido los siguientes errores:\n'+reportToSave.errorMessage.join('\n'))
      }else{
        delete (reportToSave as any).errorMessage;
        var customReport = {form:`${this.customform.id}`,timestammp:moment().toDate(),formData:reportToSave}


        this.reportService.updatecustomreport(this.report.id,customReport,this.userSessionService.accessToken).subscribe( r=> {
          resolve(true)
        })
      }

    })

  }

  /**
   * Elimina el reporte
   * @returns
   */
  deleteReport(): Promise<any> {
    return new Promise((resolve,reject) => {
      this.reportService.deletecustomreport(this.report.id,this.userSessionService.accessToken).subscribe(report => {
          resolve(true);
      })
    })
  }

  /**
   * @ignore
   */
  ngOnInit(): void {

  }

  /**
   * Abre la imagen
   * @param i
   */
  open(i){
    console.log("Queremos abrir la imagen "+i);
    var fotos = [{src:i,thumb:i}]
    this.lightbox.open(fotos,0);
  }

  /**
   * Obtiene los datos de un campo del customform
   * @param fieldid Identificador del campo
   * @returns
   */
  getFieldData(fieldid): any{

    //console.log(this.customform)
    //console.log(fieldid)

    let field = this.customform.dynamic_form.Fields.find( e => e.id === fieldid)
    if (field.type == 'field_list' || field.type == 'region_list' ||field.type == 'product_list' || field.type == 'machinery_list' || field.type == 'user_list'){
      field.elements = this.sourcesList[field.type]
    }

    //console.log(field);
    if(field != undefined){
      return {title:field.title,type:field.type,pos:field.pos,elements:field.elements,mutiple:field.multiselect};
    }else{
      return {title:fieldid,type:'text',pos:100};
    }

  }


  /**
   * Inicializa el mapa openlayers
   */
  initMap() {
    console.log("Inicializamos el mapa")
    this.vectorSource = new VectorSource();
    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer({
      source: new OSM(),
    }) ,
    new TileLayer({
      visible: true,
      title: 'Mapa Geográfico',
      type:'base',
      source: new WMTS({
        attributions:
          'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
          'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
        url:
          'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
        layer: '0',
        matrixSet: 'EPSG:3857',
        format: 'image/png',
        projection: projection,
        tileGrid: new WMTSTileGrid({
          origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
          resolutions: resolutions,
          matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
      }),
    }),
        new VectorLayer({
          source: this.vectorSource,
        }),
      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    console.log("Mapa inicializado")
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {

    setTimeout(()=>{
      this.initMap();



    if(this.report.showLocation){

      this.loadLocation()
    }


  }, 750)



  }

  /**
   * Carga la ubicación del mapa
   */
  loadLocation() {
    console.log("Cargar localizacion")
    console.log(this.report.form_data.location)
    this.geometryEditable = false


    if (typeof this.report.form_data.location != 'undefined'){
      var coordinates = [];

      coordinates = this.report.form_data.location.geometry.coordinates;


      var feature = JSON.parse(JSON.stringify(this.report.form_data.location));


      console.log(feature)

      if (feature.geometry.type == "Polygon"){
        this.geometryEditable = true
          feature.geometry.coordinates[0] = feature.geometry.coordinates[0].map(function(coordinate){
            return olProj.fromLonLat(coordinate);
          })

          coordinates = this.report.form_data.location.geometry.coordinates[0][0]
      }else{
        feature.geometry.coordinates = olProj.fromLonLat(feature.geometry.coordinates)

      }
      console.log(feature)
      var olfeature = new GeoJSON().readFeature(feature)
      console.log(olfeature);

    var iconFeature = new Feature({
      geometry: olfeature.getGeometry(),
      name: this.report.diseaseName,

      informe: this.report,
    });



    if (feature.geometry.type == "Polygon"){
      olfeature.setStyle(new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(0, 0, 255, 0.1)',
        }),
      }))

    }else{
      olfeature.setStyle(new Style({
        image: new Icon({
          color: '#32CD32',
          crossOrigin: 'anonymous',
          src: 'assets/images/marker_sampling.png',
          scale: 0.5,
        }),
      }));
    }




    console.log(olfeature)
    this.vectorSource.addFeature(olfeature);


    this.map.getView().setCenter(olProj.fromLonLat(coordinates));


    this.map.getView().setZoom(15);
    }else{
      this.report.showLocation = false;
    }




  }

  /**
   * Genera los listados de entidades
   */
  async generateSourcesList() {
    this.sourcesList = {}
    this.sourcesList['user_list'] = (await this.promisify(this.userSessionService.getCachedUsersList())).map(i => i.name+' '+i.surname)
    /*
    this.sourcesList['field_list'] = (await this.promisify(this.userSessionService.getCachedFieldList())).map(i => i.name)
    this.sourcesList['region_list'] = (await this.promisify(this.userSessionService.getCachedFieldList())).reduce((acc,f) => {
      if(!acc.includes(f.region)){
        acc.push(f.region)
      }
      return acc;
  },[]);

    this.sourcesList['product_list'] = (await this.promisify(this.userSessionService.getCachedProductList())).map(i => i.name)
    this.sourcesList['machinery_list'] = (await this.promisify(this.userSessionService.getCachedMachineryList())).map(i => i.name)
  */
  }

  /**
   * @ignore
   * @param obs
   * @returns
   */
  async promisify(obs: Observable<any>): Promise<any> {
    return new Promise((resolve,reject) => {
        obs.subscribe(d => {
          resolve(d);
        },error => {
          reject(error)
        })
    })
  }

  /**
   * Lanza la edición de geometría
   */
  async editGeometry(){
    var editorref = await  this.dialogService.open(GeometryEditorComponent)
    if(this.report.form_data.location != null){
      editorref.componentRef.instance.cargarGeometria(this.report.form_data.location.geometry)
    }

    editorref.componentRef.instance.getGeometry().subscribe( geo => {
      if (null != geo){
        console.log(geo);
        this.report.form_data.location = {type:'Feature',geometry:geo}
        this.vectorSource.clear()
        this.report.showLocation = true;
        this.loadLocation();
      }else{
        this.vectorSource.clear()
        this.report.showLocation = false;
      }

    })
   }

   /**
    * @ignore
    * @param archivos
    * @param item
    */
   actualizarImagen(archivos: FileList,item: any){


    item.imagen = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(archivos.item(0)));
    item.imagenth = item.imagen
    const file = archivos.item(0)
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

        item.value = 'dataImageName:/'+this.userSessionService.user.company.id+'/'+this.userSessionService.user.id+'/'+file.name+';'
        + (reader.result as String).split(',')[1]
        console.log(reader.result);
    };

  }



  formatDate(date:string,format:string){
    var r = moment(date).format(format);
    if (r == 'Invalid date') r = '';
    return r;

  }


}
